import React, { useEffect, useState } from "react";
import api, { API, getToken } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { FileText, Search, Download } from "lucide-react";
import { CategoryChipSelector } from "@/components/CategoryManager";

export default function Reports() {
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("");

  useEffect(() => {
    (async () => {
      const [r, c] = await Promise.all([api.get("/reports"), api.get("/reports/categories")]);
      setItems(r.data);
      setCategories(c.data);
    })();
  }, []);

  const filtered = items.filter((r) => {
    if (cat && (r.category || "").toLowerCase() !== cat.toLowerCase()) return false;
    if (q && !r.title.toLowerCase().includes(q.toLowerCase())) return false;
    return true;
  });

  const download = (r) => {
    const url = `${API}/reports/${r.id}/download?auth=${encodeURIComponent(getToken() || "")}&disposition=attachment`;
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener";
    a.download = r.filename || `${r.title || "report"}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  return (
    <div className="space-y-5">
      <div>
        <h1 className="font-display text-3xl font-bold tracking-tight text-slate-900">Analisi mensile e altri report</h1>
        <p className="text-sm text-slate-500 mt-1">Biblioteca delle analisi mensili e degli altri report Adybo disponibili.</p>
      </div>

      <div className="card-elevated p-4 flex flex-wrap gap-2 items-center">
        <div className="relative flex-1 min-w-[220px]">
          <Search size={15} className="absolute left-3 top-2.5 text-slate-400" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca report…" className="w-full pl-9 pr-3 py-2 rounded-lg border border-slate-200 text-sm outline-none focus:border-blue-500" data-testid="report-search" />
        </div>
      </div>

      <CategoryChipSelector
        categories={categories}
        activeCat={cat}
        onChange={setCat}
        totalCount={items.length}
        testId="report-cat-chips"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {filtered.map((r) => (
          <div key={r.id} className="card-elevated p-5 flex flex-col" data-testid={`report-card-${r.id}`}>
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center mb-3 shadow-md shadow-blue-500/30">
              <FileText className="text-white" size={22} />
            </div>
            <div className="text-[11px] text-slate-500 uppercase tracking-wider font-semibold">{r.category}</div>
            <div className="font-display font-bold text-slate-900 mt-1 line-clamp-2 flex-1">{r.title}</div>
            {r.description && <div className="text-xs text-slate-500 mt-2 line-clamp-2">{r.description}</div>}
            <div className="mt-3 text-[11px] text-slate-400">{fmtDate(r.report_date)}</div>
            <button
              type="button"
              onClick={() => download(r)}
              className="mt-4 text-sm font-semibold flex items-center gap-1.5 text-blue-600 hover:text-purple-600 self-start"
              data-testid={`report-download-${r.id}`}
            >
              <Download size={14} /> Scarica PDF
            </button>
          </div>
        ))}
        {filtered.length === 0 && <div className="text-sm text-slate-500">Nessun report disponibile.</div>}
      </div>
    </div>
  );
}
